module.exports = __webpack_public_path__ + "img/th_19mm_Scalps.1d87283e.jpg";